import React from 'react';

const LayoutDashboard = () => {

	return (
		<div className='background-main-png'></div>
	)
}

export default LayoutDashboard